import { shallowEqual, useSelector } from 'react-redux';
import MediaService from '../../../../services/MediaService';

import './SingingPage.scss';

const SingingPage = ({ children, onBackClick, step }) => {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const musicIcon = MediaService.getImage(
    '/Module1Images/Ico_Music.png',
    login
  );

  return (
    <>
      <section className='singing-page'>
        <header style={{ position: step === 'intro' ? 'initial' : 'absolute' }}>
          {step !== 'ending' && <h1>{login.firstname}&apos;s Recording</h1>}
          {step === 'ending' && (
            <>
              <h1>Do you want to use this recording?</h1>
              <h3>
                Your voice will be muted when it&apos;s the character&apos;s turn to
                sing.
              </h3>
            </>
          )}
          {step === 'intro' && (
            <figure>
              <img src={musicIcon} alt='singing' />
            </figure>
          )}
        </header>

        {children}

        {step !== 'record' && (
          <footer id='nav'>
            <button className='link-button' onClick={onBackClick}>
              &#60; BACK
            </button>
          </footer>
        )}
      </section>
    </>
  );
};

export default SingingPage;
